/* <curve-reveal> — curved bottom for a "revealing" section.

   Renders a section-coloured panel hanging below its section with a rounded
   bottom; as the section scrolls up, the panel's height animates to 0, so the
   curve flattens and uncovers whatever sits beneath it (the footer / next
   section). Scroll-scrubbed via GSAP ScrollTrigger and kept in step with Lenis —
   the same approach as media-banner.js.

   Progressive enhancement: with GSAP/ScrollTrigger missing or reduced motion,
   the panel is left flat (height 0) — a normal straight section edge. Cleans up
   and re-inits after a theme-editor re-render. */
if (!customElements.get('curve-reveal')) {
  class CurveReveal extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;

      this.panel = this.firstElementChild;
      if (!this.panel) return;

      var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      var ready = window.gsap && window.ScrollTrigger;

      this.max = parseFloat(this.getAttribute('data-depth'));
      if (isNaN(this.max)) this.max = 180;

      // Flat fallback — a plain straight edge.
      if (reduce || !ready || this.max <= 0) { this.draw(0); return; }

      var gsap = window.gsap;
      gsap.registerPlugin(window.ScrollTrigger);

      // Keep ScrollTrigger in step with Lenis' smoothed scroll (wire once).
      if (window.lenis && !window.__curveRevealLenisSynced) {
        window.__curveRevealLenisSynced = true;
        window.lenis.on('scroll', window.ScrollTrigger.update);
      }

      var self = this;
      var state = { d: this.max };
      this.draw(this.max);

      // Fully bowed when the section's bottom edge enters the viewport; flattens
      // as you scroll, reaching FLAT exactly at the page bottom — i.e. when the
      // footer is fully revealed. Ending on the document (not 'top top') matters
      // because a pinned/sticky footer stops the section short of the top, so a
      // section-relative end would never finish flattening.
      this.tween = gsap.to(state, {
        d: 0,
        ease: 'none',
        onUpdate: function () { self.draw(state.d); },
        scrollTrigger: {
          trigger: this,
          start: 'top bottom',
          endTrigger: document.documentElement,
          end: 'bottom bottom',
          scrub: 1,
          invalidateOnRefresh: true,
        },
      });
    }

    disconnectedCallback() {
      if (this.tween) {
        if (this.tween.scrollTrigger) this.tween.scrollTrigger.kill();
        this.tween.kill();
        this.tween = null;
      }
      this.initialized = false;
    }

    draw(d) { this.panel.style.height = d + 'px'; }
  }

  customElements.define('curve-reveal', CurveReveal);
}
